import React, { useState } from 'react';
import Button from '../../../../component/ui/Button';
import { toast } from 'react-toastify';
import { create_purchase_bill, updatePurchaseBill } from '../../../../services/purchase_bill';
import { useBlocker, useNavigate, useParams } from 'react-router-dom';
import Modal from '../../../../component/modal/Modal';
import { useSelector } from 'react-redux';
import { hasPermission } from '../../../../utils/controller';

function CreatePurchaseBillHeader({
	tableError,
	error,
	setError,
	errorCells,
	setErrorCells,
	purchaseBillFormData,
	calculateTotalBill,
}) {
	const navigate = useNavigate();
	const suburl = localStorage.getItem('suburl');
	const param = useParams();
	const id = param?.id;
	const [loading, setLoading] = useState({
		isLoading: false,
		status: null,
	});
	const [isNextLocation, setIsNextLocation] = useState(null);
	const [isLocationBlocker, setIsLocationBlocker] = useState(true);
	const [isPurchaseBillAutoSave, setIsPurchaseBillAutoSave] = useState(false);
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);

	function checkValidation(status) {
		let newError = { ...error };
		if (
			!purchaseBillFormData.vendor_id ||
			purchaseBillFormData.vendor_id === '' ||
			purchaseBillFormData.vendor_id === undefined
		) {
			newError.vendor_id = 'Please select a valid vendor from the list.';
		} else {
			delete newError.vendor_id;
		}

		if (status === 1) {
			if (
				!purchaseBillFormData.purchase_order_id ||
				purchaseBillFormData.purchase_order_id === '' ||
				purchaseBillFormData.purchase_order_id === undefined
			) {
				newError.purchase_order_id = 'Please select purchase order number from the list';
			} else {
				delete newError.purchase_order_id;
			}
			if (
				!purchaseBillFormData.bill_amount ||
				purchaseBillFormData.bill_amount === '' ||
				purchaseBillFormData.bill_amount === undefined
			) {
				newError.bill_amount = 'Please enter bill amount in the field';
			} else if (
				Number(purchaseBillFormData.bill_amount).toFixed(2) !== calculateTotalBill().toFixed(2)
			) {
				newError.bill_amount = 'Bill Amount is not match from total bill';
			} else {
				delete newError.bill_amount;
			}
			if (
				!purchaseBillFormData.bill_number ||
				purchaseBillFormData.bill_number === '' ||
				purchaseBillFormData.bill_number === undefined
			) {
				newError.bill_number = 'Please enter bill number in the field';
			} else {
				delete newError.bill_number;
			}
			if (
				!purchaseBillFormData.bill_date ||
				purchaseBillFormData.bill_date === '' ||
				purchaseBillFormData.bill_date === undefined ||
				(purchaseBillFormData.bill_date !== '' && newError.bill_date)
			) {
				newError.bill_date = newError.bill_date ?? 'Please enter bill date in the field';
			} else {
				delete newError.bill_date;
			}
			if (
				!purchaseBillFormData.date ||
				purchaseBillFormData.date === '' ||
				purchaseBillFormData.date === undefined ||
				(purchaseBillFormData.date !== '' && newError.date)
			) {
				newError.date = newError.date ?? 'Please enter date in the field';
			} else {
				delete newError.date;
			}
			// if (!purchaseBillFormData.due_date ||
			// 	purchaseBillFormData.due_date === '' ||
			// 	purchaseBillFormData.due_date === undefined
			// ) {
			// 	newError.due_date = 'Please enter due date in the field';
			// } else {
			// 	delete newError.due_date;
			// }
			if (
				!purchaseBillFormData.payment_method ||
				purchaseBillFormData.payment_method === '' ||
				purchaseBillFormData.payment_method === undefined
			) {
				newError.payment_method = 'Please enter payment method in the field';
			} else {
				delete newError.payment_method;
			}
		} else {
			delete newError.purchase_order_id;
			delete newError.bill_amount;
			delete newError.bill_number;
			delete newError.bill_date;
			delete newError.date;
			delete newError.payment_method;
		}
		if (status === 1) {
			let newErrorCell = [...errorCells];
			if (purchaseBillFormData.purchase_bill_products.length > 0) {
				let productIndex = Number(purchaseBillFormData.purchase_bill_products.length) - 1;
				if (
					purchaseBillFormData.purchase_bill_products[productIndex].product_id === '' ||
					purchaseBillFormData.purchase_bill_products[productIndex].product_id === null
				) {
					newErrorCell = [...newErrorCell, { index: productIndex, name: 'product_id' }];
					newError.product_id = '';
				} else {
					delete newError.product_id;
				}
				if (
					purchaseBillFormData.purchase_bill_products[productIndex].batch_no === '' ||
					purchaseBillFormData.purchase_bill_products[productIndex].batch_no === null
				) {
					newErrorCell = [...newErrorCell, { index: productIndex, name: 'batch_no' }];
					newError.batch_no = '';
				} else {
					delete newError.batch_no;
				}
				if (
					purchaseBillFormData.purchase_bill_products[productIndex].quantity === '' ||
					purchaseBillFormData.purchase_bill_products[productIndex].quantity === null ||
					Number(purchaseBillFormData.purchase_bill_products[productIndex].quantity) === 0
				) {
					newErrorCell = [...newErrorCell, { index: productIndex, name: 'quantity' }];
					newError.quantity = '';
				} else {
					delete newError.quantity;
				}
				if (
					purchaseBillFormData.purchase_bill_products[productIndex].free_quantity === '' ||
					purchaseBillFormData.purchase_bill_products[productIndex].free_quantity === null
				) {
					newErrorCell = [...newErrorCell, { index: productIndex, name: 'free_quantity' }];
					newError.free_quantity = '';
				} else {
					delete newError.free_quantity;
				}
				if (
					purchaseBillFormData.purchase_bill_products[productIndex].purchase_rate === '' ||
					purchaseBillFormData.purchase_bill_products[productIndex].purchase_rate === null ||
					Number(purchaseBillFormData.purchase_bill_products[productIndex].purchase_rate) === 0
				) {
					newErrorCell = [...newErrorCell, { index: productIndex, name: 'purchase_rate' }];
					newError.purchase_rate = '';
				} else {
					delete newError.purchase_rate;
				}

				if (
					purchaseBillFormData.purchase_bill_products[productIndex].mfg_date === '' ||
					purchaseBillFormData.purchase_bill_products[productIndex].mfg_date === null
				) {
					newErrorCell = [...newErrorCell, { index: productIndex, name: 'mfg_date' }];
					newError.mfg_date = '';
				} else {
					delete newError.mfg_date;
				}

				if (
					purchaseBillFormData.purchase_bill_products[productIndex].exp_date === '' ||
					purchaseBillFormData.purchase_bill_products[productIndex].exp_date === null
				) {
					newErrorCell = [...newErrorCell, { index: productIndex, name: 'exp_date' }];
					newError.exp_date = '';
				} else {
					delete newError.exp_date;
				}

				if (
					purchaseBillFormData.purchase_bill_products[productIndex].mrp === '' ||
					purchaseBillFormData.purchase_bill_products[productIndex].mrp === null ||
					Number(purchaseBillFormData.purchase_bill_products[productIndex].mrp) === 0
				) {
					newErrorCell = [...newErrorCell, { index: productIndex, name: 'mrp' }];
					newError.mrp = '';
				} else {
					delete newError.mrp;
				}
			} else {
				newErrorCell = [...newErrorCell, { index: 0, name: 'product_id' }];
				newError.product_id = '';
				newErrorCell = [...newErrorCell, { index: 0, name: 'batch_no' }];
				newError.batch_no = '';
				newErrorCell = [...newErrorCell, { index: 0, name: 'quantity' }];
				newError.quantity = '';
				newErrorCell = [...newErrorCell, { index: 0, name: 'purchase_rate' }];
				newError.purchase_rate = '';
				newErrorCell = [...newErrorCell, { index: 0, name: 'mfg_date' }];
				newError.mfg_date = '';
				newErrorCell = [...newErrorCell, { index: 0, name: 'exp_date' }];
				newError.exp_date = '';
				newErrorCell = [...newErrorCell, { index: 0, name: 'mrp' }];
				newError.mrp = '';
			}
			setErrorCells(newErrorCell);
		} else {
			delete newError.product_id;
			delete newError.batch_no;
			delete newError.quantity;
			delete newError.free_quantity;
			delete newError.purchase_rate;
			delete newError.mfg_date;
			delete newError.exp_date;
			delete newError.mrp;
		}

		if (
			Object.keys(newError).length > 0 ||
			(status === 1 && tableError) ||
			(status === 1 &&
				Number(purchaseBillFormData.bill_amount).toFixed(2) !== calculateTotalBill().toFixed(2))
		) {
			setError(newError);
			return true;
		} else {
			return false;
		}
	}

	async function handleSavePurchaseBill(status) {
		const isErrorShow = checkValidation(status);
		if (isErrorShow) {
			if (Number(purchaseBillFormData.bill_amount).toFixed(2) !== calculateTotalBill().toFixed(2)) {
				toast.error('Please mismatch bill amount and bill total');
			} else {
				toast.error('Unable to create purchase bill');
			}
		} else {
			try {
				setLoading((prev) => ({
					...prev,
					isLoading: true,
					status: status,
				}));
				const body = {
					...purchaseBillFormData,
					status,
					e_way_bill: purchaseBillFormData.e_way_bill?.e_way_bill_status
						? purchaseBillFormData.e_way_bill
						: {},

					purchase_bill_products:
						status === 0
							? purchaseBillFormData?.purchase_bill_products.map((prod) => {
									const { discount, free_quantity, quantity, mrp, purchase_rate, amount, ...rest } =
										prod;
									return {
										...rest,
										quantity: Number(quantity),
										free_quantity: Number(free_quantity),
										discount: discount === '' || discount === null ? 0 : Number(discount),
										mrp: Number(mrp),
										purchase_rate: Number(purchase_rate),
										amount: Number(amount),
									};
								}) /// status 0
							: purchaseBillFormData?.purchase_bill_products
									.filter(
										(product) =>
											product.product_id !== '' &&
											product.product_id !== null &&
											product.quantity !== 0 &&
											product.quantity !== null &&
											product.quantity !== '' &&
											product.mrp !== 0 &&
											product.mrp !== null &&
											product.mrp !== '' &&
											product.purchase_rate !== 0 &&
											product.purchase_rate !== null &&
											product.purchase_rate !== '' &&
											product.amount !== 0 &&
											product.amount !== null &&
											product.amount !== '',
									)
									.map((prod) => {
										const {
											discount,
											free_quantity,
											quantity,
											mrp,
											purchase_rate,
											amount,
											...rest
										} = prod;
										return {
											...rest,
											quantity: Number(quantity),
											free_quantity: Number(free_quantity),
											discount: discount === '' || discount === null ? 0 : Number(discount),
											mrp: Number(mrp),
											purchase_rate: Number(purchase_rate),
											amount: Number(amount),
										};
									}),
				};

				const { purchase_bill } = await create_purchase_bill(body);
				toast.success('Purchase Bill Created Successfully');

				if (status === 1 && purchaseBillFormData?.payment_method !== 'Credit') {
					setIsLocationBlocker(false);
					setIsPurchaseBillAutoSave(false);
					setTimeout(() => {
						navigate(`/user/${suburl}/payment-made-create`, {
							state: { key: purchase_bill?.vendor_id, value: '' },
						});
					}, 300);
				} else {
					setIsLocationBlocker(false);
					setIsPurchaseBillAutoSave(false);
					setTimeout(() => {
						navigate(`/user/${suburl}/purchases-bills`);
					}, 300);
				}
			} catch (error) {
				toast.error(error.message || 'Something went wrong!');
			} finally {
				setLoading((prev) => ({
					...prev,
					isLoading: false,
					status: status,
				}));
			}
		}
	}

	const handleUpdatePurchaseBill = async (status) => {
		const isErrorShow = checkValidation(status);
		if (isErrorShow) {
			if (Number(purchaseBillFormData.bill_amount).toFixed(2) !== calculateTotalBill().toFixed(2)) {
				toast.error('Please mismatch bill amount and bill total');
			} else {
				toast.error('Unable to create purchase bill');
			}
		} else {
			try {
				setLoading((prev) => ({
					...prev,
					isLoading: true,
					status: status,
				}));
				await updatePurchaseBill({ ...purchaseBillFormData, status });
				toast.success('Purchase Bill Updated Successfully');
				navigate(`/user/${suburl}/purchases-bills`);
			} catch (error) {
				toast.error(error.message || 'Something went wrong!');
			} finally {
				setLoading((prev) => ({
					...prev,
					isLoading: false,
					status: null,
				}));
			}
		}
	};

	useBlocker((tx) => {
		if (!id && isLocationBlocker) {
			setIsNextLocation(tx);
			setIsPurchaseBillAutoSave(true);
			return true;
		}
		return false;
	});
	return (
		<div className="product-pg-header add-product header-position-sticky">
			<p>
				{id && !id.includes('ytr') && !id.includes('por') && !id.includes('pr')
					? 'Update '
					: 'Create New '}
				Purchase Bill
			</p>
			<div className="add-product-button">
				<Button
					type="button"
					className="btn-primary mt-0 px-4"
					disabled={
						loading?.status === 1 && loading.isLoading
							? true
							: id && !id.includes('ytr') && !id.includes('por') && !id.includes('pr')
								? !hasPermission('purchases.purchase_bills.edit', user?.role?.role_permissions)
								: !hasPermission('purchases.purchase_bills.create', user?.role?.role_permissions)
					}
					button="Save"
					loader={loading?.status === 1 && loading.isLoading}
					onClick={() => {
						setIsPurchaseBillAutoSave(false);
						if (id && !id.includes('ytr') && !id.includes('por') && !id.includes('pr')) {
							handleUpdatePurchaseBill(1);
						} else {
							handleSavePurchaseBill(1);
						}
					}}
				/>
				<Button
					type="button"
					className="btn-primary mt-0 px-4"
					button="Save as Draft"
					disabled={
						loading?.status === 0 && loading.isLoading
							? true
							: id && !id.includes('ytr') && !id.includes('por') && !id.includes('pr')
								? !hasPermission('purchases.purchase_bills.edit', user?.role?.role_permissions)
								: !hasPermission('purchases.purchase_bills.create', user?.role?.role_permissions)
					}
					loader={loading?.status === 0 && loading.isLoading}
					onClick={() => {
						setIsPurchaseBillAutoSave(false);
						if (id && !id.includes('ytr') && !id.includes('por') && !id.includes('pr')) {
							handleUpdatePurchaseBill(0);
						} else {
							handleSavePurchaseBill(0);
						}
					}}
				/>
				<Button
					type="button"
					className="mt-0 btn-danger add-pro"
					button=""
					close
					onClick={() => navigate(`/user/${suburl}/purchases-bills`)}
				/>
			</div>
			{isPurchaseBillAutoSave && (
				<Modal
					className="deleteVendorsModal"
					title="Purchase Bill Auto Save"
					isOpen={isPurchaseBillAutoSave}
					onClose={() => {
						setIsPurchaseBillAutoSave(false);
					}}
					cancelButton={() => {
						setIsPurchaseBillAutoSave(false);
					}}
				>
					<div
						style={{
							textAlign: 'center',
							backgroundColor: '#E6F5FF',
							padding: '20px 10px',
							marginBottom: '20px',
							borderRadius: '5px',
							fontWeight: '600',
							color: 'black',
						}}
					>
						You have unsaved changes. Do you want to continue without saving?
					</div>

					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							gap: 10,
							justifyContent: 'end',
						}}
					>
						<Button
							type="button"
							button="Leave Without Saving"
							className="mt-0 px-4 btn-danger relative"
							onClick={() => {
								setIsLocationBlocker(false);
								setIsPurchaseBillAutoSave(false);
								setTimeout(() => {
									navigate(isNextLocation.nextLocation?.pathname);
								}, 300);
							}}
						/>

						<Button
							type="button"
							button="Save As Draft"
							disabled={
								!hasPermission('purchases.purchase_bills.create', user?.role?.role_permissions)
							}
							className="mt-0 px-4 btn-primary relative"
							onClick={() => {
								setIsPurchaseBillAutoSave(false);
								handleUpdatePurchaseBill(0);
							}}
						/>
						<Button
							type="button"
							button="Save and Continue"
							disabled={
								!hasPermission('purchases.purchase_bills.create', user?.role?.role_permissions)
							}
							className="mt-0 px-4 btn-primary relative"
							onClick={() => {
								setIsPurchaseBillAutoSave(false);
								handleUpdatePurchaseBill(1);
							}}
						/>
					</div>
				</Modal>
			)}
		</div>
	);
}

export default CreatePurchaseBillHeader;
